import { useT } from "../lib/i18n";

export function EnglishBarrier() {
  const t = useT();

  return (
    <section
      id="english-meetings"
      className="border-t border-margin dark:border-paper/10"
    >
      <div className="mx-auto max-w-3xl px-6 py-24">
        <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
          {t.englishBarrier.label}
        </p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink dark:text-paper leading-tight">
          {t.englishBarrier.heading}
        </h2>
        <p className="mt-8 text-lg text-ink/75 dark:text-paper/75 leading-relaxed">
          {t.englishBarrier.body1}
        </p>
        <p className="mt-6 text-lg text-ink/75 dark:text-paper/75 leading-relaxed">
          {t.englishBarrier.body2}
        </p>

        <ul className="mt-10 space-y-3">
          {t.englishBarrier.bullets.map((b) => (
            <li
              key={b}
              className="flex gap-3 text-ink/80 dark:text-paper/80 leading-relaxed"
            >
              <span
                className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-ink/40 dark:bg-paper/40"
                aria-hidden
              />
              <span>{b}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
